import { gql } from "@apollo/client";

export const getCurrentUserPermissions = `{
                    getUserApplication
                }`;

export const getUserPermissions = ` 
                query($userId: UUID!)
                         {       
                           getUserPermissions(userId:$userId)       
                          }
             `;
export const getAdminPermissions = ` 
                query($userId: UUID!)
                         {       
                           getAdminPermissions(userId:$userId)       
                          }
             `;
export const updateUserPermissions = ` 
                mutation (
                    $userId: UUID!
                    $userPermission: String!
                    )
                      {
                            updateUserPermissions(input:{userId:$userId,userPermission:$userPermission})
                            {
                            strings
                            }
  
                        }
                        `;
export const updateAdminPermissions = ` 
                mutation (
                    $userId: UUID!
                    $adminPermission: String!
                    )
                      {
                            updateAdminPermissions(input:{userId:$userId,adminPermission:$adminPermission})
                            {
                            strings
                            }
  
                        }
                        `;
export const getDermariseUserProfile = ` query( $userId: UUID! ) {
                                          userById(id:$userId){
                                                        id
                                                        firstName
                                                        lastName
                                                        phone
                                                        country
                                                        email
                                                        createdAt
                                                        dermariseProfileByUserId{
                                                                educationalArea
                                                                profTitle
                                                                postalCode
                                                                city
                                                                workDept
                                                                streetAddress
                                                                                }
    
                                                         }
                                            }
                                            `;

export const getSeaUserProfile = `query( $userId: UUID! ) {
                                          userById(id:$userId){
                                                         id
                                                         firstName
                                                         lastName
                                                         phone
                                                         country
                                                         email
                                                         status
                                                         createdAt
                                                         seaProfileByUserId{
                                                                 medicalInstitude
                                                                 physicalAddress
                                                                          }
                                                         }
                                                   }
                                            `;

export const updateUserSeaStatus = ` mutation ( $userId: UUID! ,$status :Int!)  {
                                             updateUserById(input:{id:$userId,userPatch:{status:$status}}){
                                                user{
                                                        id
                                                        firstName
    	                                                lastName
    	                                                phone
    	                                                country
    	                                                email
    	                                                createdAt
    	                                                status
                                                        seaProfileByUserId{
                                                            medicalInstitude
                                                            physicalAddress
                                                        }
                                                     }
                                                }
                                            }`;
export const getUserProfile = `
            query( $id: UUID! ) {
                userById(id:$id){
                                firstName
                                lastName
                                phone
                                country
                                createdAt

                                }
                   }
             `;

export const createDermariseCongess = ` 
               mutation ($userId: UUID!, $name: String! ,$paths: String!)
               {
                    createAbbvieDermriseCongress(input:{abbvieDermriseCongress:{ userId : $userId, congressName : $name, congressPath : $paths}}){
                    abbvieDermriseCongress{
                                        userId
                                        congressName
                                        congressPath
                                     }
                            }
                      }`;

export const getAllDermariseCongress = `  query($userId: UUID!)
                                                       {
                                                          allAbbvieDermriseCongresses(filter:{userId:{equalTo:$userId}}){
                                                            nodes{
                                                              userId
                                                              congressPath
                                                              congressName
                                                            }
                                                          }
                                                        }`;

export const deleteCongress = ` 
                mutation (
                    $userId: UUID!
                    $congressPath: String!
                    )
                      {
                             deleteAbbvieDermriseCongressByUserIdAndCongressPath(input:{userId:$userId,congressPath:$congressPath}){
                                  deletedAbbvieDermriseCongressId

                              }
  
                        }`;

export const getAllUser = `
                                    query($userId:UUID!){
                                    allUsers(filter:{id:{notEqualTo:$userId}}){
                                        nodes{
                                          id
                                          firstName
                                          lastName
                                          phone
                                          country
                                          createdAt
                                          email
                                          userType
                                        }
                                      }
                                    } `;

export const GET_CURRENT_USER = `query{
                                 currentUser{
                                                id
                                                firstName
                                                lastName
                                                phone
                                                country
                                                createdAt
                                                email
                                                userType
                                                status
                                                adminPermissions
                                                basicAuthPermissions
                                            }
                                    }`;

export const createDermarisePin = `mutation( $userId: UUID!
                                            $userPin: String!
                                            $expiryDate:Date!
                                           )                      
                                        {
                                         createDermrisePin(input:{userId:$userId,userPin:$userPin,expiryDate:$expiryDate}){
                                         abbvieDermrisePin{
                                                        userId
                                                        userPin
                                                        expiryDate
                                                     }
                                                 }
                                          }`;

export const getAllDermarisePins = `query($userId: UUID!)
                                        {
                                         allAbbvieDermrisePins(filter:{userId:{equalTo:$userId}}){
                                         nodes{
                                              userPin
                                              expiryDate
                                              }
                                          }
                                        }
                                        `;

export const getPermissions = ` query($userId:UUID!){
                                    getPermissions(userId:$userId)
                                    {
                                     adminPermissions
                                     userPermissions
                                     readPermissions
                                     countryPermissions
                                     basicAuthPermissions
                                     basicLoginUserPermissions
                                     } 
                                    }
                                     `;
export const updatePermission = `mutation(
                                         $userId:UUID!
                                         $countryPermissions:[String]!
                                         $adminPermissions:[String]!
                                         $userPermissions:[String]!
                                         $readPermissions:[String]!
                                        ){
                                        updatePermissions(input:{userId:$userId,adminPermissions:$adminPermissions,readPermissions:$readPermissions,userPermissions:$userPermissions,countryPermissions:$countryPermissions}){
                                                            allPermission{
                                                            adminPermissions
                                                            userPermissions
                                                            readPermissions
                                                            countryPermissions
                                                            }
                                                        }
                                                    }`;

export const deleteDermarisePin = `mutation ($userPin: String!){
                                           deleteAbbvieDermrisePinByUserPin(input:{userPin:$userPin}){
                                                                        abbvieDermrisePin {
                                                                                        userId
                                                                                        expiryDate
                                                                                      }
                                                                            }
                                                                        }`;

export const createDermaUser = `mutation($input : RegisterDarmaUserInput! ){
                                        registerDarmaUser(input: $ input){
                                                user{
                                                     firstName
                                                     lastName
                                                     }
                                                     }
                                                   }
                                                `;

export const createAbbvieProUser = `mutation($user: CreateUserByAdminInput!){
  createUserByAdmin(input:$user){
    user{
      id
      firstName
      lastName
    }
  }
}`;
export const reassignPassword = `mutation($userId: UUID! $password: String! $minLength: String!){
                                          reassignPassword(input:{
                                            userId:$userId,
                                            newPassword:$password,
                                            minLength:$minLength
                                            
                                          })
                                          {
                                            string
                                          }
                              }`;
export const UPDATE_PERMISSION_GQL = gql`
    mutation (
        $userId: UUID!
        $countryPermissions: [String]!
        $adminPermissions: [String]!
        $userPermissions: [String]!
        $readPermissions: [String]!
        $basicAuthPermissions: [String]!
    ) {
        updatePermissions(
            input: {
                userId: $userId
                adminPermissions: $adminPermissions
                readPermissions: $readPermissions
                userPermissions: $userPermissions
                countryPermissions: $countryPermissions
                basicAuthPermissions: $basicAuthPermissions
            }
        ) {
            allPermission {
                adminPermissions
                userPermissions
                readPermissions
                countryPermissions
                basicAuthPermissions
            }
        }
    }
`;
export const UPDATE_BASIC_USER_PERMISSION = gql`
    mutation ($userId: UUID!, $basicLoginUserPermissions: [String]!) {
        updateBasicUserPermissions(
            input: { userId: $userId, basicLoginUserPermissions: $basicLoginUserPermissions }
        ) {
            allPermission {
                basicLoginUserPermissions
            }
        }
    }
`;
export const CHANGE_PASSWORD = `
mutation (
            $oldPassword: String!
            $newPassword: String!
            )    {
              changePasswordPiap(input:{ oldPassword : $oldPassword,newPassword: $newPassword}){
                                  string
                                  }
                    } `;
// InfocenterDerma Query

export const createInfoCenterDermaUser = `mutation($input : RegisterAbbvieInfocenterDermaUserInput! ){
                                        registerAbbvieInfocenterDermaUser(input: $ input){
                                                user{
                                                     firstName
                                                     lastName
                                                     }
                                                     }
                                                   }
                                                `;
export const getAllInfocenterDermaPins = `query($userId: UUID!)
                                        {
                                         allAbbvieInfocenterDermaPins(filter:{userId:{equalTo:$userId}}){
                                         nodes{
                                              userPin
                                              expiryDate
                                              }
                                          }
                                        }
                                        `;
export const createInfocenterDermaPin = `mutation(
                                            $userId: UUID!
                                            $userPin: String!
                                            $expiryDate:Datetime
                                            )                      
                                        {
                                         createAbbvieInfocenterDermaPin(input:{abbvieInfocenterDermaPin:{userId:$userId,userPin:$userPin,expiryDate:$expiryDate}}){
                                         abbvieInfocenterDermaPin{
                                                        userId
                                                        userPin
                                                        expiryDate
                                                     }
                                                 }
                                          }`;
export const deleteInfocenterDermaPin = `mutation ($userPin: String!){
                                           deleteAbbvieInfocenterDermaPinByUserPin(input:{userPin:$userPin}){
                                                                        abbvieInfocenterDermaPin {
                                                                                        userId
                                                                                        expiryDate
                                                                                      }
                                                                            }
                                                                        }`;

export const getUserActivityLogs = `
  query(
    $activityType: String
    $fromDate:Date!
    $toDate:Date!
  ) {
    getActivityLog(
      activityType:$activityType,
      fromDate:$fromDate,
      toDate:$toDate
    ) {
      nodes{
        schemaName
        tableName
        fullName
        category
        updateAt
      }
    }
  }
`;

export const getAllAdminUser = `query{
  allUsers(filter:{userType:{notEqualTo:0}}){
    nodes{
      id
      email
      userType
      
    }
  }
}
`;
export const deleteHCPUser = `mutation( $userId: UUID!){
                              deleteUserById(input:{id:$userId}){
                                user{
                                 id
                                }
                              }
                            }`;

export const INFOCENTER_DARMA_PROFILE_FRAGMENT = gql`
    fragment abbvieInfocenterDermaProfile on AbbvieInfocenterDermaProfile {
        userId
        educationalArea
        profTitle
        postalCode
        city
        workDept
        streetAddress
    }
`;
// export const UPDATE_INFOCENTER_DERMA_USER_PROFILE = gql`
//     mutation (
//         $id: UUID!
//         $userPatch: UserPatch!
//         $abbvieInfocenterDermaProfile: AbbvieInfocenterDermaProfileInput!
//     ) {
//         upsertAbbvieInfocenterDermaProfile(
//             input: { abbvieInfocenterDermaProfile: $abbvieInfocenterDermaProfile }
//         ) {
//             abbvieInfocenterDermaProfile {
//                 ...abbvieInfocenterDermaProfile
//             }
//         }
//         updateUserById(input: { id: $id, userPatch: $userPatch }) {
//             user {
//                 ...user
//                 abbvieInfocenterDermaProfileByUserId {
//                     ...abbvieInfocenterDermaProfile
//                 }
//             }
//         }
//     }
//     ${USER_FRAGMENT}
//     ${INFOCENTER_DARMA_PROFILE_FRAGMENT}
// `;

export const applicationList = {
    DERMARISE: "abbvie_dermrise",
    SEA: "sea",
    INFOCENTER: "infocenter",
};
